<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-agreement comp">
        <!--<el-checkbox name="type">
            <div class="agree-list clear">
                <b>我已阅读并同意</b>
                <span v-for="item of protocol" :key="item.id" v-on:click.prevent="agreementCon(item)">《{{ item.title }}》</span>
            </div>
        </el-checkbox>-->
        <el-dialog :title="agrCon.title" :visible.sync="centerDialogVisible" :fullscreen="isFullscreen">
            <div v-html="agrCon.content" />
            <div slot="footer" class="dialog-footer align-c">
                <el-button type="primary" v-on:click="confirmCon">
                    我已知晓
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "Agreement",
    props: {
        data: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            protocol: [],
            centerDialogVisible: false,
            agrCon: {},
            isFullscreen: false,
            index: 0
        };
    },
    watch: {
        value(val) {
            if (val) {
                if(this.protocol.length === this.index && this.index > 0){
                    this.$emit("all-read", true);
                    return;
                }
                this.getAgreement();
            }
        },
        centerDialogVisible(val){
            if(!val){
                this.$emit("all-read", false);
            }
        }
    },
    mounted () {
    },
    methods: {
        // 查询具体合同内容
        agreementCon (val) {
            let _this = this;
            const _data = {
                id: val.id,
                version: val.version
            };
            this.$util.request("common/protocol/content", _data).then(res => {
                if (res.data) {
                    const con = res.data[0];
                    if (con) {
                        _this.agrCon = con;
                        _this.centerDialogVisible = true;
                    }
                }
            });
        },
        confirmCon() {
            this.centerDialogVisible = false;
            this.index++;
            if (this.index === this.protocol.length) {
                this.$emit("all-read", true);
                return;
            }
            setTimeout(() => {
                this.autoShow();
            }, 1000);
        },
        autoShow() {
            if (this.protocol.length === 0) {return this.$emit("all-read", true);}
            this.agreementCon(this.protocol[this.index]);
        },
        getAgreement () {
            let _this = this;
            this.$util.getProtocol(this.data).then(res => {
                _this.protocol = res;
                _this.autoShow();
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-agreement {
    width: 100%;
    .el-checkbox__input {
        vertical-align: top;
    }
    .el-checkbox__label {
        line-height: 40px;
        color: $text-color1;
        cursor: default;
        .agree-list{display: inline-block;}
        b{
            float: left;
            line-height: 20px;
            font-weight: normal;
            color: $text-color1;
        }
        span {
            color: $color-b;
            cursor: pointer;
            line-height: 20px;
            display: inline-block;
            float: left;
            &:after {
                content: "、";
                color: $text-color1;
            }
            &:last-child:after {
                content: "";
            }
            &:hover {
                color: $color-a;
            }
        }
    }
}
</style>
